import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PlayblastRemovekeyNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M7.20001 4.8H9.60001C9.60001 3.4744 10.6745 2.4 12 2.4V0C9.35331 0 7.20001 2.1533 7.20001 4.8Z"
        fill={color}
      />
      <path
        d="M12 0V2.4C13.3256 2.4 14.4 3.4744 14.4 4.8H16.8C16.8 2.1533 14.6467 0 12 0Z"
        fill={color}
      />
      <path
        d="M19.2 3.59998H4.80002C3.47452 3.59998 2.40002 4.67448 2.40002 5.99998V7.19998C2.40002 7.86268 2.93732 8.39998 3.60002 8.39998H20.4C21.0627 8.39998 21.6 7.86268 21.6 7.19998V5.99998C21.6 4.67448 20.5255 3.59998 19.2 3.59998Z"
        fill={color}
      />
      <path
        d="M17.9939 7.19995L16.9653 21.6V24C18.2244 24 19.2694 23.0269 19.3592 21.771L20.4 7.19995H17.9939Z"
        fill={color}
      />
      <path
        d="M3.59998 7.19995L4.64078 21.771C4.73048 23.0269 5.77558 24 7.03468 24V21.6L6.00608 7.19995H3.59998Z"
        fill={color}
      />
      <path d="M12.9 11.4H11.1V18.6H12.9V11.4Z" fill={color} />
      <path
        d="M9.29646 11.3253L7.50348 11.4747L8.10344 18.6747L9.89643 18.5253L9.29646 11.3253Z"
        fill={color}
      />
      <path
        d="M14.7023 11.3253L14.1035 18.5254L15.8983 18.6747L16.4971 11.4746L14.7023 11.3253Z"
        fill={color}
      />
      <path
        d="M12 19.5C12.4969 19.5 12.9 19.0969 12.9 18.6H11.1C11.1 19.0969 11.5031 19.5 12 19.5Z"
        fill={color}
      />
      <path
        d="M8.99882 19.5C9.02342 19.5 9.04922 19.5 9.07502 19.4976C9.56952 19.4554 9.93861 19.0195 9.89651 18.5249L8.10352 18.6749C8.14222 19.1437 8.53592 19.5 8.99882 19.5Z"
        fill={color}
      />
      <path
        d="M14.1035 18.525C14.0613 19.0196 14.4305 19.4555 14.925 19.4977C14.9508 19.5001 14.9766 19.5001 15 19.5001C15.4641 19.5001 15.8578 19.1438 15.8976 18.6751L14.1035 18.525Z"
        fill={color}
      />
      <path
        d="M12 10.5C11.5031 10.5 11.1 10.9031 11.1 11.4H12.9C12.9 10.9031 12.4969 10.5 12 10.5Z"
        fill={color}
      />
      <path
        d="M8.32497 10.5035C7.83037 10.5445 7.46127 10.9793 7.50347 11.4749L9.29647 11.3249C9.25547 10.8303 8.83477 10.459 8.32497 10.5035Z"
        fill={color}
      />
      <path
        d="M15.675 10.5035C15.1336 10.4542 14.7445 10.8316 14.7023 11.325L16.4976 11.475C16.5374 10.9793 16.1696 10.5445 15.675 10.5035Z"
        fill={color}
      />
      <path d="M16.9653 21.6H7.03479V24H16.9653V21.6Z" fill={color} />
    </BaseIcon>
  ),
);

PlayblastRemovekeyNsk.displayName = 'PlayblastRemovekeyNsk';
